import { ColumnDef } from '@3ddv/software-division-components/backoffice/table';
import {
  gsActionsColumn,
  gsImageColumn,
} from '../../shared/ui/table/gs-table.columns';
import { Upsell } from './models/upsell.model';

export function buildUpsellColumns(
  onToggleActive: (upsell: Upsell) => void,
  onDelete: (upsell: Upsell) => void,
  onEdit: (upsell: Upsell) => void,
  canEdit = true
): ColumnDef<Upsell>[] {
  const imageColumn = gsImageColumn<Upsell>({
    image: upsell => upsell.urlImage,
  });

  const nameColumn: ColumnDef<Upsell> = {
    id: 'name',
    header: 'Name',
    accessorFn: upsell => upsell.name,
  };

  const descriptionColumn: ColumnDef<Upsell> = {
    id: 'description',
    header: 'Description',
    accessorFn: upsell => upsell.description,
  };

  const buyerTypeColumn: ColumnDef<Upsell> = {
    id: 'buyerTypeId',
    header: 'Buyer Type ID',
    accessorFn: upsell => upsell.buyerTypeId,
  };

  const actionsColumn = gsActionsColumn<Upsell>({
    actions: [
      {
        id: 'toggle',
        label: upsell => (upsell.active ? 'On' : 'Off'),
        tone: upsell => (upsell.active ? 'positive' : 'negative'),
        dataCy: upsell => `upsell-enable-button-${upsell.id}`,
      },
      {
        id: 'edit',
        label: 'Edit',
        dataCy: upsell => `upsell-edit-button-${upsell.id}`,
      },
      {
        id: 'delete',
        label: 'Delete',
        destructive: true,
        dataCy: upsell => `upsell-delete-button-${upsell.id}`,
      },
    ],
    onSelect: (actionId, upsell) => {
      if (actionId === 'toggle') {
        onToggleActive(upsell);
      } else if (actionId === 'edit') {
        onEdit(upsell);
      } else if (actionId === 'delete') {
        onDelete(upsell);
      }
    },
    rowDataCy: upsell => `upsell-row-${upsell.id}`,
  });

  return [
    imageColumn,
    nameColumn,
    descriptionColumn,
    buyerTypeColumn,
    ...(canEdit ? [actionsColumn] : []),
  ];
}
